"use strict";

var _interopRequireDefault = require("@babel/runtime/helpers/interopRequireDefault");

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.markAllRead = exports.MARK_ALL_READ = void 0;

var _regenerator = _interopRequireDefault(require("@babel/runtime/regenerator"));

var _asyncToGenerator2 = _interopRequireDefault(require("@babel/runtime/helpers/asyncToGenerator"));

var MARK_ALL_READ = "\n  mutation TrackEvent {\n    markAllRead\n  } \n";
exports.MARK_ALL_READ = MARK_ALL_READ;

var markAllRead = function markAllRead(client) {
  return /*#__PURE__*/(0, _asyncToGenerator2["default"])( /*#__PURE__*/_regenerator["default"].mark(function _callee() {
    var _results$data;

    var results, markAllRead;
    return _regenerator["default"].wrap(function _callee$(_context) {
      while (1) {
        switch (_context.prev = _context.next) {
          case 0:
            if (client) {
              _context.next = 2;
              break;
            }

            return _context.abrupt("return", Promise.resolve(undefined));

          case 2:
            _context.next = 4;
            return client.mutation(MARK_ALL_READ).toPromise();

          case 4:
            results = _context.sent;
            markAllRead = results === null || results === void 0 ? void 0 : (_results$data = results.data) === null || _results$data === void 0 ? void 0 : _results$data.markAllRead;
            return _context.abrupt("return", {
              markAllRead: markAllRead
            });

          case 7:
          case "end":
            return _context.stop();
        }
      }
    }, _callee);
  }));
};

exports.markAllRead = markAllRead;